import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AuthSurface from '../components/auth/AuthSurface';
import PrivateRoute from '../components/PrivateRoute';
import ApprovedRoute from '../components/ApprovedRoute';
import { useAuth } from '../context/AuthContext';

const AccountCenter = lazy(() => import('../components/AccountCenter'));
const PanelWorkspace = lazy(() => import('../components/PanelWorkspace'));
const JuryTrackerPro = lazy(() => import('../components/JuryTrackerPro'));
const SessionRedirect = lazy(() => import('../components/SessionRedirect'));
const InvitationRedirect = lazy(() => import('../components/InvitationRedirect'));
const OrganizationAdmin = lazy(() => import('../components/OrganizationAdmin'));
const QuestionBankLibrary = lazy(() => import('../components/QuestionBankLibrary'));
const CaseSetup = lazy(() => import('../components/CaseSetup'));
const OrganizationInvitationRedirect = lazy(() =>
  import('../components/OrganizationInvitationRedirect')
);

const RouteFallback = () => (
  <main className="flex min-h-screen items-center justify-center bg-stone-50 text-sm text-slate-500">
    Loading workspace…
  </main>
);

const AppRoutes = () => {
  const { currentUser } = useAuth();

  return (
    <Suspense fallback={<RouteFallback />}>
    <Routes>
      {/* Authentication Routes */}
      <Route element={<AuthSurface />}>
        <Route path="/login" element={<></>} />
        <Route path="/signup" element={<></>} />
        <Route path="/forgot-password" element={<></>} />
      </Route>
      
      {/* Protected Routes */}
      <Route element={<PrivateRoute />}>
        <Route path="/workspace" element={<PanelWorkspace />} />
        <Route path="/workspace/account" element={<AccountCenter />} />
        <Route path="/workspace/:organizationId/admin" element={<OrganizationAdmin />} />
        <Route path="/workspace/:organizationId/question-banks" element={<QuestionBankLibrary />} />
        <Route path="/organization-invite/:token" element={<OrganizationInvitationRedirect />} />
        <Route path="/dashboard" element={<Navigate replace to="/workspace" />} />
      </Route>
      <Route element={<ApprovedRoute />}>
        <Route path="/workspace/:organizationId/cases/:caseId/setup/:step" element={<CaseSetup />} />
        <Route path="/panel/:panelId" element={<JuryTrackerPro />} />
        <Route path="/session/:sessionCode" element={<SessionRedirect />} />
        <Route path="/join/:sessionCode" element={<SessionRedirect />} />
        <Route path="/invite/:token" element={<InvitationRedirect />} />
      </Route>
      
      {/* Redirect to workspace if logged in, otherwise to login */}
      <Route 
        path="/" 
        element={currentUser ? <Navigate replace to="/workspace" /> : <Navigate replace to="/login" />} 
      />
      
      {/* Catch all undefined routes */}
      <Route path="*" element={<Navigate replace to="/" />} />
    </Routes>
    </Suspense>
  );
};

export default AppRoutes;
